import React, { Component } from 'react'
import imageCompression from 'browser-image-compression';

export default class TestAddPage extends Component {
	state = {
		imageDisplay: null,
		imageFile: null,
		loading: false
	}

	componentDidMount() {
		if(!window.loadImage){
			window.location.reload(true);
		}
	}

	newImg = (e) => {
		if (e.target.files && e.target.files[0]) {
			const img = e.target.files[0];
			console.log(`size original ${img.size / 1024 / 1024} MB`, this.props.index);


			//if it is rotated by exif, use load-image library to correctly rotate it before compression

			imageCompression.getExifOrientation(img)
				.then(ori => {
					if (ori > 1) {
						this.rotateAndCompress(img, ori);
					} else {
						console.log("exifOrient. ok");
						this.compress(img);
					}
				})
				.catch(err => {
					console.log("error while reading exif orientation");
					this.compress(img);
				});

			this.props.onAdd(this.props.index);

			//shows current uncompressed image
			const reader = new FileReader();
			reader.onload = (eLoad) => {
				this.setState({
					imageDisplay: eLoad.target.result,
					imageFile: img,
					loading: true
				})
			}
			reader.readAsDataURL(img);

		}
	}


	render() {
		return (
			<div className="col-6 col-md-4 col-lg-3 img-col">

				{(this.state.imageDisplay && this.state.imageFile) ? (
					<div className="added-img">
						<img src={this.state.imageDisplay} alt="" className="card img-card" />

						{this.state.loading && (
							<div className="img-loading">
								<h3><i className="fas fa-spinner"></i></h3>
							</div>
						)}

						<div className="img-menu">
							{!this.props.first &&
								<i onClick={() => this.props.moveLeft(this.props.index)} className="fas fa-chevron-left"></i>
							}
							<i onClick={() => this.props.delete(this.props.index)} className="fas fa-trash"></i>
							{!this.props.last &&
								<i onClick={() => this.props.moveRight(this.props.index)} className="fas fa-chevron-right"></i>
							}
						</div>
					</div>

				) : (

						<button className="btn card img-card add-img">
							<h1><i className="fas fa-file-invoice"></i></h1>

							<input type="file" name="img" accept="image/*" onChange={this.newImg} />
						</button>
					)}

			</div>
		)
	}

	//rotates the image using load-image and then compresses it
	//otherwise strange behaviour for iOS

	rotateAndCompress(img, ori) {
		console.log("exifOrient: " + ori);
		if (window.loadImage) {
			const loadImage = window.loadImage;
			loadImage(img, (i) => {

				imageCompression.canvasToFile(i, "image/jpeg", `img${this.props.index}`, img.lastModified, 100)
					.then(file => {
						this.compress(file);
					})
					.catch(err => {
						console.log('error while reading img from canvas: ' + err);
						this.compress(img);
					});

			}, { orientation: true });
		}else{
			window.location.reload(true);
		}
	}

	//compresses the image and then updates the parent state (images array)
	compress(img) {
		console.log(`size before compression ${img.size / 1024 / 1024} MB`);

		const options = {
			maxSizeMB: 0.5,
			maxWidthOrHeight: 2560
		}

		imageCompression(img, options)
			.then(compressed => {
				const reader = new FileReader();
				reader.onload = (eLoad) => {
					this.setState({
						imageDisplay: eLoad.target.result,
						imageFile: img,
						loading: false
					});
					console.log(`size after compression ${compressed.size / 1024 / 1024} MB`, img, this.props.index);

					this.props.onLoad(this.props.index, compressed);
				}
				reader.readAsDataURL(compressed);
			})
			.catch(err => console.error(err));
	}
}
